import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, vsDark, shadesOfPurple, dracula } from "@code-surfer/themes";
import * as React from 'react';
export default {
  CodeSurfer,
  CodeSurferColumns,
  Step,
  github,
  vsDark,
  shadesOfPurple,
  dracula,
  React
};